var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('audit-etika-batuk-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }